import { RouteState } from './types';

const state: RouteState = {
    path: undefined,
    url: undefined,
    isExact: undefined,
    params: {},
    routeState: {},
    isFirstPage: true,
};

export default state;
